import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { Player, UserSettings } from 'src/models/player.model';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { MyScores, Scores } from 'src/models/myscores.model';
import { UserService } from 'src/services/user.service';
import { PlayerService } from '../players/players.service';
import { FormControl, FormGroup } from '@angular/forms';
import { distinct } from 'rxjs/operators';

@Component({
  selector: 'next-ladder',
  templateUrl: './nextladder.component.html',
  styleUrls: ['nextladder.component.scss']
})
export class NextLadderComponent implements OnInit {
  public busy: boolean = false;
  public newLadderForm: FormGroup;

  constructor(private authorizeService: AuthorizeService,
    private userSvc: UserService, private http: HttpClient,
    private router: Router, private playerSvc: PlayerService,
    private aRoute: ActivatedRoute) {
    this.busy = false;

    this.newLadderForm = new FormGroup({
      ladderId: new FormControl('WAITING_ROOM'),
      levelId: new FormControl(17),
    });
    // make sure the level id selected is a NUMBER
    this.newLadderForm.controls.levelId.valueChanges
      .pipe(distinct())  // avoid infinite loop
      .subscribe(val => this.newLadderForm.controls.levelId.setValue(+val));
    this.levels.push({ value: '17', name: 'Club Level Player' });
    this.levels.push({ value: '18', name: 'Better than a Club Level Player' });
    this.levels.push({ value: '16', name: 'Senior (55+)' });

    this.newLadderForm.controls.ladderId.valueChanges
      .subscribe(val => {
        this.levels.length = 0;
        if (val == 'WAITING_ROOM') {
          this.levels.length = 0;
          this.levels.push({ value: '17', name: 'Club Level Player' });
          this.levels.push({ value: '18', name: 'Better than a Club Level Player' });
          this.levels.push({ value: '16', name: 'Senior (55+)' });
        }
        else {
          this.levels.length = 0;
          this.levels.push({ value: '19', name: 'Club Level Doubles Player' });
          this.levels.push({ value: '20', name: 'Better than a Club Level Doubles Player' });
          this.levels.push({ value: '10', name: 'Senior Doubles (55+)' });
        }
      });
  }
  public levels: any[] = [];

  ngOnInit(): void {

  }

  public submit(): void {
    console.log(this.newLadderForm.value);
    //if( this.newLadderForm.value.ladderId == '' || this.newLadderForm.levelId)
    this.http.post('/api/joinladder', this.newLadderForm.value).subscribe(
      (resp: { status: string }) => {
        if (resp.status == "registered") {
          this.userSvc.clearCache();
          localStorage.setItem('ladderId', this.newLadderForm.value.ladderId);
          localStorage.setItem('levelId', '' + this.newLadderForm.value.levelId);
          this.router.navigate(['/home']);
        }
        else alert(resp.status)
      },
      (resp: { error: any }) => alert(resp.error.status)
    )
  }

}
